import React from 'react'

function useFetch(url = '', number) {
    const [state, setState] = React.useState([])

    const [img, setImage] = React.useState([])

    const [rawData, setData] = React.useState()

    let num = Math.floor(Math.random() * 10)

    React.useEffect(() => {


        fetch(url, {'origin': '*', 'Access-Control-Allow-Origin': '*'})
            .then(res => res.json())
            .then(
                data => {

                    setState(data.hits[number].recipe.label)
                    setImage(data.hits[number].recipe.image)
                    console.log(data)
                    setData(data.hits)

                }
            )
            .catch(error => {
                console.log(error)
                setState(null)
            })




    }, [url, number])

    return { state, img, rawData}
}

export default useFetch
//axios